import { Colors, Services } from '@sigma-frontend-libs/commons'

import { components, icons } from '@/utils'

import filterDate from '@/components/filter/date'
import info from '@/components/info'
import selectorOwner from '@/components/selector/owner'
import encoding from '@/components/services/report-manager/commons/form/encoding'
import filterBy from '@/components/services/report-manager/commons/form/filterBy'
import typeField from '@/components/services/report-manager/commons/form/type'
import readonly from '@/components/services/report-manager/queue/form/readonly'
import { serviceNameKebabCase, serviceNameViaPoint } from '@/components/services/report-manager/queue/utils'
import sticker from '@/components/sticker'

function renderNameField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.name,
        label: this.getTranslate(`${Services['report-manager']}.labels.name`),
        dense: true,
        autofocus: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.name = event
        },
        keypress: event => {
          if (event.keyCode === 13) {
            this.$emit('submit', this.proxy)
          }
        }
      }
    }
  )
}
function renderTypeField(h) {
  return h(
    typeField,
    {
      props: {
        value: this.proxy.type
      },
      on: {
        input: event => {
          this.proxy.type = event
        }
      }
    }
  )
}
function renderIsUrgentField(h) {
  return h(
    components.switch,
    {
      props: {
        value: this.proxy.isUrgent,
        tooltip: this.getTranslate(`${serviceNameViaPoint}.tooltips.isUrgent`),
        outline: true
      },
      on: {
        input: event => {
          this.proxy.isUrgent = event
        }
      }
    }
  )
}
function renderRequired(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-form-row`
    },
    [
      renderTypeField.call(this, h),
      renderIsUrgentField.call(this, h)
    ]
  )
}

function renderDateRangeRequiredError(h) {
  if (this.dateRangeIsRequired && this.dateRangeIsEmpty) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${serviceNameViaPoint}.errors.required.dateRange`),
          color: Colors.error
        }
      }
    )
  }
}
function renderDateRangeFilter(h) {
  return h(
    filterDate,
    {
      props: {
        value: this.proxy.dateRange,
        backendGeneration: 'nest',
        onlyDate: this.dateRangeIsByDays,
        clearable: true
      },
      on: {
        input: event => {
          this.proxy.dateRange = event
        }
      }
    }
  )
}
function renderDateRangeByDaysInfo(h) {
  if (this.dateRangeByDaysInfo) {
    return h(
      info,
      {
        props: {
          value: this.dateRangeByDaysInfo
        }
      }
    )
  }
}
function renderDateRange(h) {
  if (this.dateRangeIsRequired) {
    return h(
      'div',
      {
        class: `${serviceNameKebabCase}-form-column`
      },
      [
        renderDateRangeRequiredError.call(this, h),
        renderDateRangeFilter.call(this, h),
        renderDateRangeByDaysInfo.call(this, h)
      ]
    )
  }
}

function renderFilterByActivator(h) {
  return h(
    sticker,
    {
      props: {
        value: this.getTranslate(`${Services['report-manager']}.labels.filterBy`),
        label: this.getTranslate(`${Services['report-manager']}.hints.filterBy.${this.filterByHintState}`),
        labelColor: this.filterByLabelColor,
        button: this.filterByActivatorButton,
        icon: icons.filter_list,
        color: Colors.grey,
        onClick: () => {
          return null
        },
        width: '100%'
      },
      slot: 'activator'
    }
  )
}
function renderEncoding(h) {
  return h(
    encoding,
    {
      props: {
        value: this.proxy.csvConfig
      },
      on: {
        input: event => {
          this.proxy.csvConfig = event
        }
      }
    }
  )
}
function renderFilterByContent(h) {
  return h(
    filterBy,
    {
      props: {
        value: this.proxy.filterBy,
        type: this.proxy.type
      },
      on: {
        input: event => {
          this.proxy.filterBy = event
        }
      }
    }
  )
}
function renderFilterBy(h) {
  return h(
    components.menu,
    {
      props: {
        closeOnContentClick: false,
        offsetDistance: 8,
        sameWidth: true,
        rounded: true
      }
    },
    [
      renderFilterByActivator.call(this, h),
      renderFilterByContent.call(this, h)
    ]
  )
}

function renderOwner(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.ownerId,
        dense: true,
        combobox: true
      },
      on: {
        input: event => {
          this.proxy.ownerId = event
        }
      }
    }
  )
}

export default function(h) {
  if (this.isNew) {
    return h(
      components.form,
      {
        class: {
          [`${serviceNameKebabCase}-form`]: true,
          [`${serviceNameKebabCase}-form--new`]: this.isNew
        }
      },
      [
        renderNameField.call(this, h),
        renderRequired.call(this, h),
        renderDateRange.call(this, h),
        renderFilterBy.call(this, h),
        renderEncoding.call(this, h),
        renderOwner.call(this, h)
      ]
    )
  }

  return h(
    readonly,
    {
      props: {
        value: this.proxy,
        service: Services['report-manager/queue']
      }
    }
  )
}
